import { getYear as getYearFns } from 'date-fns';

export default function getYear(date: Date): number {
  return getYearFns(date);
}
